import { citiesApi } from '@features/cities/api/citiesApi'
import { getMyPosition } from '@features/cities/composables/getMyPosition'
import { findCityByGeo } from '@features/cities/services/matchCityByGeo'
import type { FormattedCity, GeoAddress } from '@features/cities/types'

/**
 * Определяет ближайший город по браузерной геолокации.
 *
 * Отказ пользователя от геолокации является штатным сценарием и не прерывает
 * отображение списка городов.
 *
 * @param cities - реактивный отформатированный список городов
 * @returns состояние определения города и загрузки геопозиции
 */
export const useCityGeolocation = (cities: Ref<FormattedCity[]>) => {
  const geoData = ref<GeoAddress | null>(null)
  const isGeoLoading = ref(true)

  const detectedCity = computed(() =>
    findCityByGeo(cities.value, geoData.value),
  )

  const setGeolocation = async () => {
    try {
      const { coords } = await getMyPosition()

      geoData.value = await citiesApi.convertGeoPoint({
        latitude: coords.latitude,
        longitude: coords.longitude,
      })
    } catch {
      geoData.value = null
    }
  }

  onMounted(async () => {
    try {
      await setGeolocation()
    } finally {
      isGeoLoading.value = false
    }
  })

  return {
    detectedCity,
    isGeoLoading,
  }
}
